import {initializeStripeInstance} from './Stripe';

const initializedContainers = new WeakSet();

export const initializeStripe = root => {
    root.querySelectorAll('[data-controller="stripe"]').forEach(cardDetails => {
        if (initializedContainers.has(cardDetails)) {
            return;
        }

        initializedContainers.add(cardDetails);

        initializeStripeInstance(cardDetails);
    });
};
